var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCloseCircle = function SvgCloseCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M8.587 14.921a6.667 6.667 0 1 0 0-13.333 6.667 6.667 0 0 0 0 13.333Z",
    stroke: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m10.587 6.254-4 4M6.587 6.254l4 4",
    stroke: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export { SvgCloseCircle as ReactComponent };
export default "data:image/svg+xml,%3Csvg width='17' height='17' viewBox='0 0 17 17' fill='none' xmlns='http://www.w3.org/2000/svg'%3E %3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M8.58708 14.9212C12.269 14.9212 15.2537 11.9365 15.2537 8.25456C15.2537 4.57266 12.269 1.58789 8.58708 1.58789C4.90518 1.58789 1.92041 4.57266 1.92041 8.25456C1.92041 11.9365 4.90518 14.9212 8.58708 14.9212Z' stroke='inherit' stroke-linecap='round' stroke-linejoin='round'/%3E %3Cpath d='M10.5869 6.25391L6.58691 10.2539' stroke='inherit' stroke-linecap='round' stroke-linejoin='round'/%3E %3Cpath d='M6.58691 6.25391L10.5869 10.2539' stroke='inherit' stroke-linecap='round' stroke-linejoin='round'/%3E %3C/svg%3E";